



































































import { Vue, Component, Prop } from 'vue-property-decorator';
import YearDropdown from './YearDropdown.vue';

@Component({
    components: {
        YearDropdown,
    }
})
export default class ParsingModal extends Vue {
  @Prop({ default: new Date().getFullYear() }) selectedYear!: number;

  localSelectedYear: number = new Date().getFullYear();
  selectedFile: File | null = null

  get yearOptions(): number[] {
    const current = new Date().getFullYear()
    const years = []
    for (let y = current; y >= 2020; y--) {
      years.push(y)
    }
    return years
  }

  get selectedFileName(): string {
    return this.selectedFile ? this.selectedFile.name : ''
  }

  show() {
    this.localSelectedYear = this.selectedYear;
    this.$bvModal.show('parsing-modal')
  }

  handleHide() {
    this.selectedFile = null
    this.localSelectedYear = this.selectedYear;
  }

  handleCancel() {
    this.$bvModal.hide('parsing-modal')
  }

  triggerFileInput() {
    (this.$refs.fileInput as HTMLInputElement).click()
  }

  onFileChange(e: Event) {
    const input = e.target as HTMLInputElement
    if (input.files && input.files.length) {
      this.selectedFile = input.files[0]
    }
  }

  onYearChange() {
    this.$emit('update-year', this.localSelectedYear);
  }

  handleParsing() {
    const user = {
      userId: this.$store.getters.user_uuid,
      userName: this.$store.state.user.login ?? '',
    }
    const formData = new FormData(); 
    formData.append('file', this.selectedFile as File); 
    formData.append('year', String(this.localSelectedYear)); 
    formData.append('user', JSON.stringify(user));

    this.$emit('start-parsing', formData)
    this.$bvModal.hide('parsing-modal')
  } 
}
